import { OrderDeliveryType } from "@web-app/types";

import type {
  DetailsType,
  OrderFormField,
} from "../../settings/FormBuilderTab/types";

/**
 * Whether a form section is rendered for the given delivery type. The pickup
 * and drop-off tabs are hidden for route-optimised orders that only have the
 * other leg, so anything configured on a hidden section is never shown.
 */
export const isSectionVisible = (
  detailsType: DetailsType,
  deliveryType: OrderDeliveryType,
) => {
  if (detailsType === "pickup") {
    return (
      deliveryType === OrderDeliveryType.INDIVIDUAL_PICKUP_AND_DROPOFF ||
      deliveryType === OrderDeliveryType.ROUTE_OPT_PICKUP
    );
  }
  if (detailsType === "dropoff") {
    return (
      deliveryType === OrderDeliveryType.INDIVIDUAL_PICKUP_AND_DROPOFF ||
      deliveryType === OrderDeliveryType.ROUTE_OPT_DROPOFF
    );
  }
  return true;
};

/** Form config fields that are actually rendered for the given delivery type. */
export const getVisibleFormFields = (
  fields: OrderFormField[],
  deliveryType: OrderDeliveryType,
) =>
  fields.filter((field) => isSectionVisible(field.detailsType, deliveryType));
